import {
  getApiBaseUrl,
  getApiBetaBaseUrl,
  socketHandler,
} from "app/shared/utils";
import { sharedLib } from "@shared/services/shared.service";
import storageService from "utils/localStorageService";
import allEndpoints from "@shared/services/endpoints";
import { buildBaseQuery } from "@shared/services/baseQuery";
import { createCommonSlice } from "@shared/slices/common.slice";
import { createAuthSlice } from "@shared/slices/auth.slice";
import {
  IS_WEB_VIEW,
  IS_WHOP,
  WHOP_EXPERIENCE_ID,
  WHOP_DEV_AUTH_TOKEN,
} from "common/constants.ts";

const baseUrl = getApiBaseUrl();
const betaBaseUrl = IS_WHOP ? undefined : getApiBetaBaseUrl();
sharedLib.init(
  storageService,
  baseUrl,
  socketHandler,
  undefined,
  allEndpoints,
  buildBaseQuery,
  createCommonSlice(
    IS_WEB_VIEW ? window.isDarkMode : storageService.getIsDarkMode()
  ),
  createAuthSlice,
  IS_WEB_VIEW,
  betaBaseUrl,
  IS_WHOP,
  WHOP_DEV_AUTH_TOKEN,
  WHOP_EXPERIENCE_ID
);
